import React from "react";
import { Modal } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";

export default function Filter(props) {
  const { onHide, show, filterInputsUpdate, filterInputs } = props;

  return (
    <Modal
      size="sm"
      show={show}
      onHide={onHide}
      aria-labelledby="create"
      centered
      className="modal-right pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="create">Notifications filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 pl-4 pr-4">
          <div className="row">
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="header"
                  name="header"
                  label="Header"
                  placeholder="Header"
                  className="w-100"
                  value={filterInputs.header}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
